import { OhayoQRConfig } from '@ohayojp.com/util';

export interface QROptions extends OhayoQRConfig {
  value: string;
}
